import { render, staticRenderFns } from "./subscription-direct-debits-follow-up.vue?vue&type=template&id=2fee24a1&scoped=true&"
import script from "./subscription-direct-debits-follow-up.vue?vue&type=script&lang=ts&"
export * from "./subscription-direct-debits-follow-up.vue?vue&type=script&lang=ts&"
import style0 from "./subscription-direct-debits-follow-up.vue?vue&type=style&index=0&id=2fee24a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fee24a1",
  null
  
)

export default component.exports